export function timedSignal(timeout: number = 15_000): AbortSignal {
  const abortController = new AbortController();
  setTimeout(() => {
    abortController.abort('timeout');
  }, timeout);
  return abortController.signal;
}
